<div class="filters-container py-4">
  <form [formGroup]="filterForm" class="filter-wrapper">
    <mat-form-field floatLabel="always">
      <mat-label class="custom-mat-label">Geography</mat-label>
      <mat-select
        ngDefaultControl
        formControlName="geography"
        [panelClass]="'map-view-custom-select'"
        placeholder="Select Geography"
        (openedChange)="handleOpenedChange($event, 'geography')"
        [formControl]="mapViewFilters.geography.formControl"
      >
        <mat-option>
          <ngx-mat-select-search placeholderLabel="Search" noEntriesFoundLabel="No entries found" closeIcon="x" [formControl]="mapViewFilters.geography.filterCtrl">
          </ngx-mat-select-search>
        </mat-option>
        <!-- <mat-option #allSelectedGeography (click)="toggleAllSelection('geography', allSelectedGeography)" [value]="''">Select All</mat-option> -->
        <mat-option *ngFor="let geography of mapViewFilters.geography.filtered | async" [value]="geography">{{ geography }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label class="custom-mat-label">Name</mat-label>
      <mat-select
        ngDefaultControl
        formControlName="node_code"
        [panelClass]="'map-view-custom-select'"
        placeholder="Select Name"
        (openedChange)="handleOpenedChange($event, 'node_code')"
        [formControl]="mapViewFilters.node_code.formControl"
      >
        <mat-option>
          <ngx-mat-select-search placeholderLabel="Search" noEntriesFoundLabel="No entries found" closeIcon="x" [formControl]="mapViewFilters.node_code.filterCtrl">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let name of mapViewFilters.node_code.filtered | async" [value]="name">{{ name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label class="custom-mat-label">ID</mat-label>
      <input matInput placeholder="ID" [(ngModel)]="node_id" [ngModelOptions]="{ standalone: true }" [disabled]="true" />
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label class="custom-mat-label">Type</mat-label>
      <input matInput placeholder="Type" [(ngModel)]="node_type" [ngModelOptions]="{ standalone: true }" [disabled]="true" />
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label class="custom-mat-label">Location</mat-label>
      <input matInput placeholder="Location" [(ngModel)]="location" [ngModelOptions]="{ standalone: true }" [disabled]="true" />
    </mat-form-field>
    <div class="clear-btn-container" *ngIf="showClearFilter">
      <button class="mdlz-btn-clear" (click)="onClearFilter()">Clear All</button>
    </div>
  </form>
</div>
